import React, { useContext, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Box } from "@rebass/grid";
import { LoginWrapper } from "../login/styled/SLogin";
import { Header, Button, Input, ResultMessage } from "../../components";
import { ProfileContext } from "../../providers/ProfileProvider";
import { AuthenticationContext } from "../../providers/AuthenticationProvider";
import { useTranslation } from "react-i18next";

interface FormValues {
  username: string;
}

const ResetPassword = () => {
  const { profileLoading, requestPasswordReset } = useContext(ProfileContext);
  const { logOut } = useContext(AuthenticationContext);
  const [passwordResetRequested, setPasswordResetRequested] = useState(false);
  const { t } = useTranslation();

  const PasswordResetSchema = Yup.object().shape({
    username: Yup.string()
      .min(2, t("VALIDATION_MIN_LENGTH_PLACEHOLDER", { placeholder: 2 }))
      .max(50, t("VALIDATION_MAX_LENGTH_PLACEHOLDER", { placeholder: 50 }))
      .required(t("VALIDATION_REQUIRED")),
  });

  return (
    <React.Fragment>
      <Formik
        validationSchema={PasswordResetSchema}
        initialValues={{
          username: "",
        }}
        onSubmit={(values: FormValues) => {
          requestPasswordReset(values.username).then(() => {
            setPasswordResetRequested(true);
            logOut();
          });
        }}
        render={({ touched, errors }) => (
          <Box id="box-password-reset" data-page-id="password-reset">
            <LoginWrapper>
              {passwordResetRequested ? (
                <ResultMessage
                  id={"box-reset-password-success"}
                  title={t("RESET_PASSWORD_TITLE")}
                  subtitle={t("RESET_PASSWORD_DONE_SUBTITLE")}
                  body={t("RESET_PASSWORD_DONE_BODY")}
                />
              ) : (
                <React.Fragment>
                  <Header>{t("RESET_PASSWORD_TITLE")}</Header>
                  <Form method="post">
                    <Box mt={30}>
                      <Input
                        id="input-username"
                        name="username"
                        type="text"
                        placeholder={t("USERNAME_OR_EMAIL")}
                        icon="user"
                        touched={touched.username}
                        error={errors.username}
                      />
                    </Box>
                    <Box my={30}>
                      <Button
                        id="button-password-reset"
                        fullWidth={true}
                        kind="primary"
                        type="submit"
                        loading={profileLoading}
                      >
                        {t("RESET")}
                      </Button>
                    </Box>
                  </Form>
                </React.Fragment>
              )}
            </LoginWrapper>
          </Box>
        )}
      />
    </React.Fragment>
  );
};

export default ResetPassword;
